module.exports = {
  ...require('./fenmarel_mestarine'),
  ...require('./flandal_steelskin'),
}
